import React, { useMemo, useRef, useState } from "react"
import ReportColumnSelector from "components/Common/ReportColumnSelector"
import { Button, Col, Form, Input, Label, Row } from "reactstrap"

import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import moment from "moment"
import { useSelector, useDispatch } from "react-redux"
import { isObject } from "lodash"
import Select from "react-select"
import {
  getMonitorItems,
  getMonitorProviderUsers,
} from "store/monitor-dashboard/monitor-dashboard-action"
import { monitorDashboardAction } from "store/monitor-dashboard/monitor-dashboard-slice"

const MonitorReceiptReportFilter = ({
  onAdvancedSearchSubmit,
  loading,
  columns = [],
  onToggleColumn = () => {},
  onReorder = () => {},
}) => {
  const dateFlatpickerfrom = useRef(null)
  const dateFlatpickerto = useRef(null)
  const [category, setCategory] = useState(null)
  const [item, setItem] = useState(null)
  const [batch_number, setBatchNumber] = useState("")
  const [ip, setIP] = useState(null)
  const [providerUser, setProviderUser] = useState(null)

  const dispatch = useDispatch()

  const [date, setDate] = useState({
    from: null,
    to: null,
  })

  // Retrieve categories data from Redux store
  const categories = useSelector(
    state => state.monitorDashboard.MonitorItemCategoires
  )

  // Retrieve items data from Redux store
  const items = useSelector(state => state.monitorDashboard.MonitorItems)
  // Retrieve ips data from Redux store
  const ips = useSelector(state => state.monitorDashboard.MonitorIps)

  // Retrieve provider users data from Redux store
  const provider_users = useSelector(
    state => state.monitorDashboard.monitorProviderUsers
  )

  // Retrieve warehouses data from Redux store
  const warehouses = useSelector(
    state => state.monitorDashboard.monitorWarehouses
  )

  // get filtered items based select box props needs
  const filteredItems = useMemo(
    () =>
      items?.data.map(item => ({
        value: item.id,
        label: `${item.unfp_item_name} ( ${item.item_name} )`,
      })),
    [items]
  )

  // Store filtered data and dispatch the action using onAdvancedSearchHandler callback function
  const handleSubmit = () => {
    let data = {}

    data.date = {
      from: date.from ? date.from : null,
      to: date.to ? date.to : null,
    }
    data.item = isObject(item) ? item.value : null
    data.providerIP = isObject(ip) ? ip.value : null
    data.providerUser = isObject(providerUser) ? providerUser.value : null
    data.category = isObject(category) ? category.value : null
    data.batchNumber = batch_number
    onAdvancedSearchSubmit(data)
  }

  // clear search when clear button clicked
  const onClearHandler = () => {
    dateFlatpickerfrom.current.flatpickr.clear()
    dateFlatpickerto.current.flatpickr.clear()
    dispatch(monitorDashboardAction.resetMonitorProviderUsers())
    setItem(null)
    setCategory(null)
    setBatchNumber("")
    setDate({ from: null, to: null })
    setIP(null)
    setProviderUser(null)
    onAdvancedSearchSubmit({})
  }

  // store Item Categories and fetch items based item category
  const onCategoryChangeHandler = cate => {
    setCategory(cate)
    dispatch(getMonitorItems(cate.value))
  }

  // store item
  const onItemChangeHandler = item => {
    setItem(item)
  }

  // store  batch number
  const onBatchNumberChange = batch_number => {
    setBatchNumber(batch_number.target.value)
  }

  // store ip and fetch provider users based ip id
  const onIPChangeHandler = ips => {
    dispatch(getMonitorProviderUsers(ips.value))
    setIP(ips)
  }

  // store provider user
  const onProviderUserChangeHandler = value => {
    setProviderUser(value)
  }

  return (
    <Form
      onSubmit={e => {
        e.preventDefault()
        handleSubmit()
        return false
      }}
    >
      <div className="mb-3">
        <Row>
          <Col>
            <Label className="form-label">Providers IPs</Label>
            {ips?.data && (
              <Select
                options={ips?.data}
                value={ip}
                onChange={onIPChangeHandler}
              />
            )}
          </Col>
          <Col>
            <Label className="form-label">Provider Users</Label>
            {provider_users?.data && (
              <Select
                options={[
                  { value: "all", label: "All" },
                  ...provider_users?.data,
                ]}
                value={providerUser}
                onChange={onProviderUserChangeHandler}
              />
            )}
          </Col>
        </Row>
      </div>
      <div className="mb-3">
        <Row>
          <Col>
            <Label className="form-label">Item Categories</Label>
            {categories?.data && (
              <Select
                options={categories?.data}
                value={category}
                onChange={onCategoryChangeHandler}
              />
            )}
          </Col>
          <Col>
            <Label className="form-label">Items</Label>
            {filteredItems && (
              <Select
                options={[{ value: "all", label: "All" }, ...filteredItems]}
                value={item}
                onChange={onItemChangeHandler}
              />
            )}
          </Col>
        </Row>
      </div>

      <div className="mb-3">
        <Row>
          <Col>
            <Label className="form-label">Batch Number</Label>
            <Input
              name="batch_number"
              placeholder="Batch Number"
              type="text"
              onChange={onBatchNumberChange}
              value={batch_number}
            />
          </Col>
        </Row>
      </div>

      <div className="mb-3 ">
        <Row>
          <Col>
            <Label className="form-label">From Date</Label>
            <Flatpickr
              ref={dateFlatpickerfrom}
              className="form-control d-block"
              placeholder="dd M,yyyy"
              options={{
                altInput: true,
                altFormat: "Y-m-d",
                dateFormat: "Y-m-d",
              }}
              onChange={value => {
                setDate(prev => {
                  return {
                    ...prev,
                    from: moment(value[0]).format("YYYY-MM-DD"),
                  }
                })
              }}
            />
          </Col>
          <Col>
            <Label className="form-label">To Date</Label>
            <Flatpickr
              ref={dateFlatpickerto}
              className="form-control d-block"
              placeholder="dd M,yyyy"
              options={{
                altInput: true,
                altFormat: "Y-m-d",
                dateFormat: "Y-m-d",
              }}
              onChange={value => {
                setDate(prev => {
                  return { ...prev, to: moment(value[0]).format("YYYY-MM-DD") }
                })
              }}
            />
          </Col>
        </Row>
      </div>
      <ReportColumnSelector columns={columns} onToggle={onToggleColumn} onReorder={onReorder} />


      <div className="d-flex flex-wrap gap-2 mb-4">
        <Button
          type="submit"
          className="btn btn-sm btn-primary"
          color="primary"
          disabled={loading}
        >
          {loading ? "Please Wait..." : "Search"}
        </Button>
        <Button
          onClick={onClearHandler}
          className="btn btn-sm btn-danger"
          color="primary"
        >
          Clear
        </Button>
      </div>
    </Form>
  )
}

export default MonitorReceiptReportFilter
